import { createRoot } from "react-dom/client";
import { App } from "./components/App.js";

const root = document.getElementById("app");
if (!root) throw new Error("#app missing");

createRoot(root).render(<App />);
